import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin: 2rem 0;
`;

export const Label = styled.label`
  font-size: 0.9rem;
  font-weight: bold;
  color: #333;
`;

export const Select = styled.select`
  padding: 0.5rem 1rem;
  font-size: 1rem;
  border: 1px solid #ccc;
  border-radius: 4px;
  background-color: #fff;
  color: #333;

  &:focus {
    outline: none;
    border-color: #999;
  }
`;

export const Option = styled.option`
  font-size: 1rem;
  color: #333;
`;